import React from 'react';
import '../../../../styles/welcome.scss';


const LogoText = (props) => {
    
    return (
    <p style={{color: props.color}} {...props} />
)}

export default LogoText